export type DateOnlyInput = string | number | Date | null | undefined;

/**
 * Normalizes a date-like value to `YYYY-MM-DD` for same-day calendar comparisons.
 * Returns an empty string for null, undefined, empty, or invalid values.
 */
export const dateOnly = (value: DateOnlyInput): string => {
  if (value == null) {
    return '';
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? '' : value.toISOString().slice(0, 10);
  }

  if (typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 10);
  }

  const str = String(value).trim();
  if (!str) {
    return '';
  }

  const isoDatePrefix = str.match(/^(\d{4}-\d{2}-\d{2})/);
  if (isoDatePrefix) {
    return isoDatePrefix[1];
  }

  const parsed = new Date(str);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }

  return parsed.toISOString().slice(0, 10);
};
